/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { StaffBuyerGroupData } from 'Types/GroupsTypes';
import HeadingWithShowAll from 'Components/globalSearch/components/HeadingWithShowAll';
import SectionHeading from 'Components/globalSearch/components/SectionHeading';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { formatNumberWithCommas, valueToObject } from 'Utils/UtilityFunctions';
import {
  groupListIcon,
  maxMobile,
  maxTablet,
  maxWidth,
  minExtraLargeScreen,
  primaryFont, primaryHeadingColor, retina, textBlack, wMedium,
  wMLight,
} from 'Utils/utilsStyle';
import { Tooltip } from 'antd';
import {
  FEED_GILROY_ROUTE, GROUP_DETAIL_ROUTE, SEARCH, SEARCH_ROUTE,
} from 'Utils/Constants';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsPagination } from 'Selector/GlobalSearchResultsSelector';
import classNames from 'classnames';
import { SearchResultsRouteState } from 'Pages/search/GlobalSearchResults';
import BuyerGroupListSkeleton from '../skeleton/BuyerGroupListSkeleton';

type Props = {
  heading?: string,
  buyerGroupsCollection?: StaffBuyerGroupData[],
  loading?: boolean,
  buyerGroupCount?: StaffBuyerGroupData[],
  count?: number,
  disableNavigation?: boolean,
  inGlobalSearch?: boolean,
  lazyMountCards?: boolean,
  query?: string,
  isPaginationOverride?: boolean,
} & typeof defaultProps;

const defaultProps = {
  heading: '',
  loading: false,
  buyerGroupsCollection: [] as StaffBuyerGroupData[],
  buyerGroupCount: [] as StaffBuyerGroupData[],
  count: 0,
  disableNavigation: false,
  inGlobalSearch: false,
  lazyMountCards: true,
  query: '',
};

const StyleWrapper = styled.div`
&.extendedSearch {
  margin-bottom: 16px;
  @media all and (min-width: ${minExtraLargeScreen}) {
    margin-bottom: 24px;
  }
}
  .buyer-container {
    display: flex;
    align-items: center;
    padding: 8px 0px;
    column-gap: 10px;
    width: 100%;
    @media all and (min-width: ${minExtraLargeScreen}) {
      padding: 10px 0px;
      column-gap: 14px;
    }
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 6px 0px;
      column-gap: 10px;
    }
    @media all and (max-width: ${maxTablet}) {
      padding: 4px 0px;
      column-gap: 6px;
    }
    @media all and (max-width: ${maxMobile}) {
      padding: 4px 0px;
      column-gap: 6px;
    }
    &:hover {
      background: #FFF;
      border-radius: 6px;
    }
    .buyer-logo {
      width: 48px;
      cursor: pointer;
      height: 42px;
      border-radius: 6px;
      border: 2px solid #001760;
      display: flex;
      align-items: center;
      justify-content: center;
      @media all and (min-width: ${minExtraLargeScreen}) {
        width: 62px;
        height: 54px;
        border-radius: 6px;
        border: 3px solid #001760;
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 48px;
        height: 40px;
        border: 2px solid #001760;
        border-radius: 4px;
      }
      @media all and (max-width: ${maxTablet}) {
        width: 38px;
        height: 34px;
        border-radius: 3px;;
      }
      @media all and (max-width: ${maxMobile}) {
        width: 34px;
        height: 30px;
        border-radius: 4px;
      }
      img{
        width: 24px;
        height: 16px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          width: 27px;
          height: 17px;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 24px;
          height: 16px;
        }
        @media all and (max-width: ${maxTablet}) {
          width: 18px;
          height: 12px;
        }
      }
    }
  
    .buyer-info {
      display: flex;
      flex-direction: column;
      column-gap: 2px;
      width: calc(100% - 48px);
      @media all and (min-width: ${minExtraLargeScreen}) {
        width: calc(100% - 62px);
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: calc(100% - 48px);
      }
      @media all and (max-width: ${maxTablet}) {
        width: calc(100% - 38px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100% - 42px);
      }
      .buyer-name {
        margin-bottom: 6px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          margin-bottom: 8px;
        }
        @media all and (max-width: ${maxTablet}) {
          margin-bottom: 2px;
        }
        @media all and (max-width: ${maxMobile}) {
          margin-bottom: 0px;
        }
        cursor: pointer;
        span {
          color: ${textBlack};
          font-family: ${primaryFont};
          font-size: 16px;
          font-weight: ${wMLight};
          line-height: 18px;
          letter-spacing: -0.52px;
          max-width: calc(100% - 50px);
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          &.triggers-bullet-tooltip {
            &.person-designation-tip {
              .ant-tooltip {
                .ant-tooltip-content {
                  .ant-tooltip-inner {
                    white-space: normal;
                  }
                }
              }
            }
          }
          @media all and (min-width: ${minExtraLargeScreen}) {
            font-size: 22px;
            line-height: 23px;
            letter-spacing: -0.99px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            font-size: 16px;
            line-height: 18px;
            letter-spacing: -0.52px;
          }
          @media all and (max-width: ${maxTablet}) {
            font-size: 14px;
            line-height: 16px;
            letter-spacing: -0.336px;
          }
          @media all and (max-width: ${maxMobile}) {
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
      .buyer-group-members-div {
        display: flex;
        column-gap: 2px;
        @media all and (max-width: ${maxMobile}) {
          margin-top: -4px
        }
      }
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
const MembersText = styled.span`
  cursor: pointer;
  color: ${primaryHeadingColor};
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wMedium};
  line-height: 16px;
  letter-spacing: -0.424px;
  @media all and (min-width: ${minExtraLargeScreen}) {
    font-size: 20px;
    letter-spacing: -0.599px;
    line-height: 21px;
    text-align: center;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.424px;
  }
  @media all and (max-width: ${maxTablet}) {
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.274px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.24px;
  }
`;

const BuyerGroupsSectionListView = function BuyerGroupsSectionListView(props: Props) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const extendedSections = ['person', 'company', 'group', 'article'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const isPaginationFromStore: boolean = useSelector(selectIsPagination);
  const isSearchPage = pathname.includes(SEARCH);

  const {
    heading,
    buyerGroupsCollection,
    loading,
    buyerGroupCount,
    count,
    disableNavigation,
    inGlobalSearch,
    lazyMountCards,
    query,
    isPaginationOverride,
  } = props;
  const isPagination = typeof isPaginationOverride === 'boolean'
    ? isPaginationOverride
    : isPaginationFromStore;
  const shouldShowPaginationSkeleton = isPagination
    && (isDetailedSearch || typeof isPaginationOverride === 'boolean');
  const host = window.location.href;
  const formattedCount = formatNumberWithCommas(count);
  const location = useLocation();
  const { state } = location as { state: SearchResultsRouteState };
  const previousPath = (state)?.previousPath ?? FEED_GILROY_ROUTE;

  const navigateToDetail = (groupId: number) => {
    if (groupId && !disableNavigation) {
      navigate(`${GROUP_DETAIL_ROUTE}${groupId}`);
    }
    if (isSearchPage) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('searchPage_buyer_group_clicked', 0, {
          group_id: groupId,
          host,
        }),
      ));
    }
  };
  const createGroupRoute = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_buyerGroups_see_all_clicked', 0, {
        host,
      }),
    ));
    window.scrollTo(0, 0);
    return navigate(`${pathname}?query=${query}&extend=group`, { state: { enableBackButton: true, previousPath } });
  };

  const navigateToSearchResult = () => {
    const path = `${SEARCH_ROUTE}${query}`;
    navigate(path, {
      state: isDetailedSearch ? { enableBackButton: true, previousPath } : { previousPath },
    });
  };

  return (
    buyerGroupsCollection.length > 0 || loading ? (
      <StyleWrapper
        className={classNames({
          extendedSearch: isDetailedSearch,
        })}
      >
        {
          loading && !isDetailedSearch ? (
            <BuyerGroupListSkeleton />
          ) : (
            <div>
              <HeadingWithShowAll
                inGlobalSearch={inGlobalSearch}
                isShowAllHidden={isDetailedSearch ? true
                  : buyerGroupCount && buyerGroupCount.length <= 2}
                leftHeading={(
                  <SectionHeading customClassName="global-search-heading">{`${heading} (${formattedCount})`}</SectionHeading>)}
                onClick={createGroupRoute}
                onSeelessClick={navigateToSearchResult}
                isDetailedSearch={isDetailedSearch}
              />
              {
                buyerGroupsCollection?.map((group) => {
                  const groupRow = (
                    <div
                      className="buyer-container list-perf-item"
                      onClick={() => navigateToDetail(group?.groupId)}
                      onKeyDown={() => navigateToDetail(group?.groupId)}
                      role="button"
                      tabIndex={0}
                    >
                      <div className="buyer-logo">
                        <img src={groupListIcon} alt="" />
                      </div>
                      <div className="buyer-info">
                        <div className="buyer-name">
                          <Tooltip
                            trigger="hover"
                            placement="top"
                            getPopupContainer={(e: HTMLElement) => e}
                            className="triggers-bullet-tooltip person-designation-tip"
                            color="#fff"
                            title={group.groupName}
                            arrow={false}
                          >
                            <span>{group.groupName}</span>
                          </Tooltip>
                        </div>
                        {group.matched_companies?.count || group.matched_persons?.count ? (
                          <div className="w-100">
                            {group.matched_persons?.count === 0 ? (
                              <div className="buyer-group-members-div">
                                <MembersText className="text-truncate">{`${group.matched_companies?.count ?? 0} ${group.matched_companies?.content ?? ''}`}</MembersText>
                                <MembersText>members</MembersText>
                              </div>
                            ) : group.matched_companies?.count ? (
                              <div className="buyer-group-members-div">
                                <MembersText className="text-truncate">{`${group.matched_companies?.count} ${group.matched_companies?.content}`}</MembersText>
                                <MembersText>members</MembersText>
                              </div>
                            ) : (
                              <div className="buyer-group-members-div">
                                <MembersText>
                                  {group.matched_persons?.count !== 1
                                    ? `${group.matched_persons?.count ?? 0} people named` : '1 person named'}
                                </MembersText>
                                <MembersText className="text-truncate">{group.matched_persons?.content || ''}</MembersText>
                              </div>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );

                  return (
                    <React.Fragment key={group.groupId}>
                      {groupRow}
                    </React.Fragment>
                  );
                })
              }
              {shouldShowPaginationSkeleton && <BuyerGroupListSkeleton />}
            </div>
          )
        }
      </StyleWrapper>
    ) : (
      null
    )
  );
};
BuyerGroupsSectionListView.defaultProps = defaultProps;
export default BuyerGroupsSectionListView;
